import { requestByConnection } from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection';
import { doRequest } from '@r1-frontend/do-request';
import { ACTIONS } from '@r1-frontend/shared/constants/analytics';
import { POLICY_PAGE_LINK } from '@r1-frontend/shared/constants/routes';
import { EProductsId } from '@r1-frontend/shared/types/EProductsId';
import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import Input from '@r1-frontend/ui-react/components/input';
import { PolicyNote } from '@r1-frontend/ui-react/components/PolicyNote';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { dataLayerForCBPhonePush, dataLayerForCBPhonePushWrapper } from '~/src/helpers/eventsForDataLayer';
import { selectCsrf } from '~/src/store/selectors/auth/selectCsrf';

import Title from '../Title';

const ConnectFormSection = styled.div`
    width: 100%;
    padding: 95px 219px 105px;
    text-align: left;

    @media only screen and (max-width: 1919px) {
        padding: 95px 190px 53px;
    }

    @media only screen and (max-width: 1365px) {
        padding: 90px 50px 57px;
    }

    @media only screen and (max-width: 1023px) {
        padding: 77px 50px 93px;
    }

    @media only screen and (max-width: 767px) {
        padding: 59px 16px 25px;
    }
`;

const ConnectForm = styled.div`
    margin-top: 31px;
    display: flex;
    flex-flow: row wrap;
    width: 100%;

    @media only screen and (max-width: 1919px) {
        margin-top: 33px;
    }
`;

const ConnectFormInputsGroup = styled.div`
    width: 100%;
    display: flex;
    flex-flow: row;

    @media only screen and (max-width: 767px) {
        flex-flow: row wrap;
    }
`;
const ConnectFormInput = styled(Input)`
    width: 412px;
    margin-right: 27px;
    margin-bottom: 0;

    @media only screen and (max-width: 1919px) {
        margin-right: 19px;
    }

    @media only screen and (max-width: 1365px) {
        margin-right: 12px;
    }

    @media only screen and (max-width: 767px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 19px;
    }
`;

const ConnectFormInfo = styled.div`
    width: 100%;
    display: flex;
    margin-top: 41px;
    align-items: center;

    @media only screen and (max-width: 767px) {
        margin-top: 0;
    }
`;

const ConnectFormButton = styled(BaseButton)`
    width: 190px;
    margin-right: 12px;

    @media only screen and (max-width: 767px) {
        width: 100%;
        margin-bottom: 19px;
        margin-right: 0;
    }
`;

const ConnectFormResponse = styled.p`
    color: ${ COLORS.lightGreen };
    ${FONTS.S};
    margin-top: 10px;

    @media(max-width: 768px) {
        text-align: center;
    }
`;

const ConnectFormError = styled(ConnectFormResponse)`
    color: ${ COLORS.red };
`;

class ConnectSection extends React.Component {
    state = {
        name: '',
        phone: '',
        status: 'hidden',
        message: null,
        isSending: true,
        beenStarted: false,
        checkAgreement: true,
    };

    nameInput = React.createRef();
    phoneInput = React.createRef();

    static propTypes = {
        title: PropTypes.string,
    };

    componentDidMount() {
        this.nameInput.current.setHasError(true);
    }

    dataLayerWrapper = () => {
        const { beenStarted } = this.state;
        if (!beenStarted) {
            dataLayerForCBPhonePush({ action: ACTIONS.started, requestId: null });
            this.setState({
                beenStarted: true,
            });
        }
    }

    onChangeValue = (nameValue, value) => {
        this.setState({
            [nameValue]: value,
        });

        this.dataLayerWrapper();

        const validName = this.nameInput.current.state.hasError;
        const validPhone = this.phoneInput.current.state.hasError;

        if (!validName && !validPhone) {
            this.setState({
                isSending: false,
            });
        } else {
            this.setState({
                isSending: true,
            });
        }
    };

    submitHandler = async(e) => {
        e.preventDefault();
        const validName = this.nameInput.current.state.hasError;
        const validPhone = this.phoneInput.current.state.hasError;

        if (!validName && !validPhone) {
            const { name, phone }  = this.state;
            const dataParams = {
                fio: name,
                phone,
                product_id: [EProductsId.telephony],
                csrf: this.props.csrf,
            };
            const resp = await doRequest.apiRequest(requestByConnection(dataParams));
            if (resp.isSuccess) {
                const { status, message } = resp.payload;
                const ok = !!status;

                dataLayerForCBPhonePushWrapper({
                    status,
                    option: ok ? '' : message,
                });

                this.setState({
                    message,
                    status: ok,
                    name: '',
                    phone: '',
                });

                this.phoneInput.current.resetStateWithUpdates();
                // @TODO iu-react components/input/input resetStateWithUpdates очищает поле и тд. только с type=phone
                this.nameInput.current.inputRef.current.value = '';
                this.nameInput.current.state.inputVal = null;
                this.nameInput.current.state.touched = false;

                this.nameInput.current.state.hasError = true;
                this.phoneInput.current.state.hasError = true;

                this.setState({
                    isSending: true,
                });
            } else {
                this.setState({
                    message: 'Не удалось отправить заявку. Пожалуйста, попробуйте еще раз.',
                    status: false,
                    isSending: true,
                });

                dataLayerForCBPhonePush({
                    requestId: null,
                    action: ACTIONS.error,
                });
            }
        } else {
            this.nameInput.current.state.hasError = true;
            this.phoneInput.current.state.hasError = true;

            this.setState({
                isSending: true,
            });

            return false;
        }
    }

    render() {
        const { submitHandler, onChangeValue } = this;
        const { title, className } = this.props;
        const { status, message, isSending } = this.state;

        const MessageText = (status !== 'hidden' && status)
            ? <ConnectFormResponse>{message}</ConnectFormResponse>
            : <ConnectFormError>{message}</ConnectFormError>;

        const buttonText = 'Отправить заявку';

        return (
        <ConnectFormSection className={className} id='formCallBack'>
            <Title as='h2' title={title}/>
            <ConnectForm>
            <ConnectFormInputsGroup>
                <ConnectFormInput
                    type='name'
                    name='Имя'
                    ref={this.nameInput}
                    placeholder='Ваше имя'
                    errorMessage='Должны быть только буквы'
                    onChange={(event) => onChangeValue('name', event)}
                    required
                />
                <ConnectFormInput
                    type='phone'
                    name='Телефон'
                    ref={this.phoneInput}
                    placeholder='Телефон'
                    errorMessage='Заполните телефон'
                    onChange={(event) => onChangeValue('phone', event)}
                    required
                />
            </ConnectFormInputsGroup>
            <ConnectFormInfo>
                <ConnectFormButton
                    type={btnTypes.ACCENT}
                    onClick={(event) => submitHandler(event)}
                    disabled={isSending}
                >
                    {buttonText}
                </ConnectFormButton>
                <PolicyNote
                    data-test='agreement'
                    buttonText={buttonText}
                    agreeUrl={POLICY_PAGE_LINK}
                />
            </ConnectFormInfo>
            {status !== 'hidden' && MessageText}
            </ConnectForm>
        </ConnectFormSection>
        );
    }
}

const mapStateToProps = state => ({
    csrf: selectCsrf(state),
});

export default connect(mapStateToProps)(ConnectSection);
